import { render, staticRenderFns } from "./ItemIcon.vue?vue&type=template&id=3e3ffa23&"
import script from "./ItemIcon.vue?vue&type=script&lang=js&"
export * from "./ItemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports